import React, { useState } from 'react'

import HomeContainer from '../../Container/HomeContainer2'
import VocationalResumeContents from '../VocationalResumeContents'

import Spinner from '../../../Components/Spinner/Spinner'

const VocationalSharedResume = (props) => {
  const [user, setUSer] = useState(props.location.data)

  if (user) {
    return (
      <HomeContainer
        isViewAsTeacher={false}
        footer={null}
        isShowWhereby={false}
        isShowPoliceCheckWwcc={true}
        tabResumeActive={false}
        tabVetResumeActive={true}
        isShared
        user={user}
      >
        <VocationalResumeContents user={user} isViewAsTeacher={false} />
      </HomeContainer>
    )
  }
  // else return <div>Loading</div>;
  else return <Spinner />
}

export default VocationalSharedResume
